import { render } from "./SubSecondSettings.vue?vue&type=template&id=d783edc2&scoped=true"
import script from "./SubSecondSettings.vue?vue&type=script&lang=js"
export * from "./SubSecondSettings.vue?vue&type=script&lang=js"

import "./SubSecondSettings.vue?vue&type=style&index=0&id=d783edc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d783edc2"]])

export default __exports__